// src/components/AddTaskModal.js
import React, { useEffect, useState } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Typography,
} from "@mui/material";
import CrmDialog from "./CrmDialog";
import API from "../utils/api";
import { tSuccess, tError } from "../utils/toast";
import ModalHeader from "./ModalHeader";


export default function AddTaskModal({ open, onClose, onCreated }) {
  const [users, setUsers] = useState([]);

  const [form, setForm] = useState({
    title: "",
    description: "",
    assigned_to: "",
    due_date: "",
    priority: "Normal",
    status: "To Do",
  });

  const resetForm = () =>
    setForm({
      title: "",
      description: "",
      assigned_to: "",
      due_date: "",
      priority: "Normal",
      status: "To Do",
    });

  const fetchUsers = async () => {
    try {
      const res = await API.get("/users/");
      setUsers(res.data);
    } catch (err) {
      console.error("Error loading users:", err);
    }
  };

  useEffect(() => {
    if (open) fetchUsers();
  }, [open]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (!form.title || !form.assigned_to) {
      tError("Please fill required fields.");
      return;
    }

    try {
      await API.post("/tasks/", form);
      tSuccess("Task created!");
      onCreated?.();      // refresh TasksPage
      onClose();          // close modal
      resetForm();        // clear form
    } catch (err) {
      console.error("Error creating task:", err);
      tError("Failed to create task.");
    }
  };

  return (
    <CrmDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <ModalHeader
  title="Add Task"
  subtitle="Create a new task, assign it to a rep, and track its completion."
/>


      <DialogContent dividers sx={{ pt: 2 }}>
        <Box display="flex" flexDirection="column" gap={2}>

          <TextField
            label="Title"
            fullWidth
            value={form.title}
            onChange={(e) => handleChange("title", e.target.value)}
          />

          <TextField
            label="Description"
            fullWidth
            multiline
            minRows={3}
            value={form.description}
            onChange={(e) => handleChange("description", e.target.value)}
          />

          <FormControl fullWidth>
            <InputLabel>Assigned Rep</InputLabel>
            <Select
              label="Assigned Rep"
              value={form.assigned_to}
              onChange={(e) => handleChange("assigned_to", e.target.value)}
            >
              {users.map((u) => (
                <MenuItem key={u.id} value={u.id}>
                  {u.username || u.first_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Due Date"
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.due_date}
            onChange={(e) => handleChange("due_date", e.target.value)}
          />

          <FormControl fullWidth>
            <InputLabel>Priority</InputLabel>
            <Select
              label="Priority"
              value={form.priority}
              onChange={(e) => handleChange("priority", e.target.value)}
            >
              <MenuItem value="Low">Low</MenuItem>
              <MenuItem value="Medium">Medium</MenuItem>
              <MenuItem value="High">High</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              label="Status"
              value={form.status}
              onChange={(e) => handleChange("status", e.target.value)}
            >
              <MenuItem value="To Do">To Do</MenuItem>
              <MenuItem value="In Progress">In Progress</MenuItem>
              <MenuItem value="Completed">Completed</MenuItem>
            </Select>
          </FormControl>

        </Box>
      </DialogContent>

      <DialogActions sx={{ mt: 1 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSave}>
          Save Task
        </Button>
      </DialogActions>
    </CrmDialog>
  );
}
